import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import RateCardValuesComponent from './rate-card-rule.component';
import RateCardBasicInfoComponent from './rate-card-basic-info.component';
import IncludeComponent from '../../../../../../common/components/common/include.component';
import ExcludeComponent from '../../../../../../common/components/common/exclude.component';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';

export const RateCardComponent = ({ onFormMediaItemChange, onInnerFormChange, customers, allTags, selectedRateCards, onInnerBasicFormChange, policyOwnerTypesListLoading, policyOwnerTypes, accountTypesListLoading, accountTypesList, accountListLoading, accountsList, id, onFormItemChange, rateCardFullRulesData, columnDefs, handleEdit, additionButtons, handleDelete, rateCardRules, back, handleFormSubmit }: any) => {

  const handleInnerMediaFormChange: any = ({ field, value }: any) => {
    onFormMediaItemChange({
      value: value.MediaFiles,
      field: 'MediaFiles',
      idx: '', //not used
    });
  };

  const tabItems = [
    {
      id: 1,
      title: 'Basic-Info',
      component: (
        <RateCardBasicInfoComponent

          accountsList={accountsList}
          accountListLoading={accountListLoading}
          accountTypesList={accountTypesList}
          accountTypesListLoading={accountTypesListLoading}
          policyOwnerTypes={policyOwnerTypes}
          policyOwnerTypesListLoading={policyOwnerTypesListLoading}
          onInnerBasicFormChange={onInnerBasicFormChange}
          selectedRateCards={selectedRateCards}
        />
      ),
      isVisible: true,
    },
    {
      id: 2,
      title: 'Include Entity',
      component: <IncludeComponent
        // allTags={allTags}
        isSaleChannel={true}
        isCustomerTag={false}
        isCustomer={true}
        isStore={true}
        isWarehouse={true}
        isState={true}
        isCountry={true}
        customers={customers}
        handleInnerFormChange={onInnerFormChange}
        selectedInclude={selectedRateCards}
      />,
      isVisible: true,
    },

    {
      id: 3,
      title: 'Exclude Entity',
      component: <ExcludeComponent
        // allTags={allTags}
        isSaleChannel={true}
        isCustomerTag={false}
        isCustomer={true}
        isStore={true}
        isWarehouse={true}
        isState={true}
        isCountry={true}
        allTags={allTags}
        customers={customers}
        handleInnerFormChange={onInnerFormChange}
        selectedExclude={selectedRateCards}
      />,
      isVisible: true,
    },
    {
      id: 4,
      title: 'Media',
      component:

        <UploadMedia
          handleInnerFormChange={handleInnerMediaFormChange}
          mediaFilesList={selectedRateCards?.MediaMappings?.MediaFiles}
          ownerTypeId={152}
          ownerId={id}
          folderName={'logisticspolicy'}
        />,
      isVisible: true,
    },

    {
      id: 5,
      title: 'Mobility',
      component:
        <RateCardValuesComponent
          handleDelete={handleDelete}
          additionButtons={additionButtons}
          handleEdit={handleEdit}
          columnDefs={columnDefs}
          rateCardFullRulesData={rateCardFullRulesData}
        />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default RateCardComponent;
